var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGaana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#E72C28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8112 15.3735C12.6185 15.3735 12.4257 15.3735 12.2972 15.3735C11.4618 15.3735 10.6908 15.3735 9.85542 15.3092C8.63454 15.1807 7.7992 14.4096 7.54217 13.3815C7.41366 12.8032 7.47791 12.2892 7.60643 11.7108C7.86345 10.2329 8.12048 8.75502 8.44177 7.27711C8.76305 5.47791 10.1767 4.19277 12.0402 4.06426C13.1325 4 14.2249 4 15.3173 4C15.8956 4 16.4739 4 17.1165 4C17.0522 4.4498 16.988 4.8996 16.9237 5.28514C16.4739 7.66265 16.0884 9.9759 15.6386 12.3534C15.3815 13.8313 15.1245 15.3092 14.8032 16.7871C14.4177 18.7791 12.8112 19.743 11.2691 19.9357C10.8835 20 10.498 20 10.1125 20C8.76305 20 7.41365 20 6.06426 20H6C6 19.9357 6 19.9357 6 19.8715C6.38554 19.2289 6.77109 18.5221 7.15663 17.8795C7.22089 17.8153 7.41366 17.751 7.54217 17.751C8.6988 17.751 9.91968 17.751 11.0763 17.751C11.9759 17.751 12.4257 17.3655 12.6185 16.5301C12.6827 16.1446 12.747 15.8233 12.8112 15.3735ZM11.9116 13.1245C12.2329 13.1888 12.49 13.1245 12.8112 13.1888C13.1325 13.1888 13.1968 13.1245 13.261 12.8032C13.5823 11.004 13.9036 9.20482 14.2249 7.40562C14.3534 6.6988 13.9679 6.31325 13.261 6.24899C12.8755 6.24899 12.49 6.24899 12.1044 6.24899C11.3333 6.24899 10.8193 6.6988 10.6265 7.46988C10.498 8.30522 10.3052 9.14056 10.1767 9.91165C10.0482 10.6827 9.91968 11.3896 9.79117 12.1606C9.72691 12.6747 10.0482 13.0602 10.5622 13.1245C11.0763 13.1888 11.5261 13.1245 11.9116 13.1245Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaana);
export default __webpack_public_path__ + "static/media/gaana.e359d207.svg";
export { ForwardRef as ReactComponent };